<header class="flex p-2" [class.app-header-pinned]="isHeaderPinned">
    @if (sessionInfo.currentTenant) {
        <div class="flex-none flex align-items-center">
            <button pButton pRipple type="button" icon="pi pi-bars"
                class="p-button-secondary p-button-outlined mr-3 button-default-outline"
                (click)="handleShowMenu()"></button>
        </div>
    }

    <div class="flex-none flex align-items-center">
        <brand-logo logoHeight="48" [tenantAssets]="this.tenantAssets" [tenantCount]="this.tenantCount"></brand-logo>
    </div>

    <div class="flex-grow-1 flex align-items-center justify-content-center">
        <app-environment-banner></app-environment-banner>
        @if (impersonationSession) {
            <p-message severity="warn"
                text="Impersonation Session will end at {{impersonationSessonEndTime | date:'dd MMM yyyy HH:mm'}}"
                styleClass="ml-2 mr-2"></p-message>
        }
    </div>

    @if (sessionInfo.isAuthenticated && sessionInfo.currentTenant) {
        <div class="flex-none flex align-items-center mr-3">
            <a [routerLink]="navigationProperties"
                routerLinkActive=BusinessObjectStatus.Active>
                <img [src]="getSafeLogo(sessionInfo.currentTenant)" alt="{{sessionInfo.currentTenant.name}}" height="48" />
            </a> 
            <span class="ml-2 mr-2 separator-bar"></span><span class="text-sm"></span>
            @if (asset) {
                @if (tenantAssets.length > 1) {
                    <div>
                        <p-select #assetDropdown="ngModel" [options]="tenantAssets" optionLabel="name" [(ngModel)]="asset"
                            (onChange)="onAssetChange()" appendTo="body" class="app-header-field">
                            <ng-template pTemplate="selectedItem">
                                <h3 style="display: inline-block;">{{asset.name}}</h3><span
                                    class="ml-2 mr-2 separator-bar"></span><span
                                    class="text-sm">{{asset.timezoneModel.name}}</span>
                            </ng-template>
                            <ng-template let-assetOption pTemplate="item">
                                <h3 style="display: inline-block;">{{assetOption.name}}</h3><span
                                    class="ml-2 mr-2 separator-bar"></span><span
                                    class="text-sm">{{assetOption.timezoneModel?.name}}</span>
                            </ng-template>
                        </p-select>
                    </div>
                }
                @if (tenantAssets.length < 2) {
                    <div class="page-header-asset-selector">
                        <h3 style="display: inline-block;">{{asset.name}}</h3><span class="ml-2 mr-2 separator-bar"></span><span
                            class="text-sm">{{asset.timezoneModel.name}}</span>
                    </div>
                }
            }
        </div>
    }

    @if (sessionInfo.isAuthenticated) {
        <div class="flex-none flex align-items-center">
            <p-splitButton label="{{username}}" icon="pi pi-user" styleClass="p-button-outlined p-button-success" [model]="items" appendTo="body" id="profileButton"></p-splitButton>
        </div>
    }

    <div class="flex-none flex align-items-center ml-2">
        <button pButton pRipple type="button"
            [icon]="isHeaderPinned ? 'pi pi-lock' : 'pi pi-lock-open'"
            class="p-button-secondary p-button-outlined button-default-outline"
            [attr.aria-label]="isHeaderPinned ? 'Unpin header' : 'Pin header'"
            [attr.title]="isHeaderPinned ? 'Unpin header' : 'Pin header'"
            (click)="toggleHeaderPinned()"></button>
    </div>

</header>

<menu-bar [(menuVisible)]="menuVisible" [tenant]="sessionInfo.currentTenant"
    [asset]="sessionInfo.currentAsset"></menu-bar>

<p-dialog header="Accept Terms and Privacy" [(visible)]="displayTermsDialog" position="top" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="false">
    <p>
        Please click the links to view the policies and terms. Once all have been viewed, you may accept.
    </p>
    <p>
        <a target='_blank' href="https://www.erm.com/privacy/" class="mr-2"
            (click)="privacyViewed=true">Privacy Policy</a>
    </p>
    <p>
        <a target='_blank' href="/account/cookie" class="mr-2" (click)="cookiesViewed=true">Cookies Policy</a>
    </p>
    <p>
        <a target='_blank' href="/account/terms" class="mr-2" (click)="termsViewed=true">Terms of Use</a>
    </p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times-circle" (click)="logout()" label="Reject"
            styleClass="p-button-text p-button-secondary"></p-button>
        <p-button icon="pi pi-check-circle" [disabled]="!privacyViewed || !cookiesViewed || !termsViewed"
            (click)="acceptedTermsAndPrivacy()" label="Accept" styleClass="p-button-text p-button-success"></p-button>
    </ng-template>
</p-dialog>